var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonster(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    fill: "#644A98"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3 51.6C40.7205 51.6 51.6 40.7205 51.6 27.3C51.6 13.8795 40.7205 3 27.3 3C13.8795 3 3 13.8795 3 27.3C3 40.7205 13.8795 51.6 27.3 51.6Z",
    fill: "#644A98"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.4283 17.1716L27.2999 26.6332L17.1714 17.1716V37.4286H21.7563V27.6335L27.2999 32.5519L32.8434 27.6335V37.4286H37.4283V17.1716Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonster);
export default __webpack_public_path__ + "static/media/monster.c9d7fc5b2b7a99abf89c4aac3cc9391f.svg";
export { ForwardRef as ReactComponent };